module.exports = __webpack_public_path__ + "img/Expo_Topic3.56bce29f.png";